const KPICard = ({ value, label, icon: Icon, trend, color = "red" }) => {
  const colorClasses = {
    red: "border-[#E30613]",
    green: "border-emerald-500",
    amber: "border-amber-500",
    blue: "border-blue-500",
    gray: "border-gray-400"
  };

  return (
    <div className={`card-kpi ${colorClasses[color]}`} data-testid={`kpi-${label?.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-start justify-between">
        <div>
          <p 
            className="kpi-value"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            {value}
          </p>
          <p className="kpi-label">{label}</p>
        </div>
        {Icon && (
          <div className="p-2 bg-gray-50 rounded-lg">
            <Icon className="w-5 h-5 text-gray-400" />
          </div>
        )}
      </div>
      {trend && (
        <div className={`mt-3 text-sm ${trend > 0 ? 'text-emerald-600' : 'text-red-600'}`}>
          {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}% vs mois dernier
        </div>
      )}
    </div>
  );
};

export default KPICard;
